// extracted by mini-css-extract-plugin
export default {"wrapper":"MonitorElements_wrapper__dJt43"};